// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list_WUyQt {
  overflow-y: auto;
  flex-basis: 450px !important;
}

.overrides_zrkYF {
  height: 100%;
}

.header_AMt7S {
  padding: var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.addButton_x7xd1 {
  margin-top: var(--size-padLarge);
}

@media only screen and (max-width: 768px) {
  .header_AMt7S {
    padding: 0;
  }

  .overrides_zrkYF {
    height: auto;
    min-width: none;
  }

  .list_WUyQt {
    flex-basis: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-operating-hours/lib/OverridesEditor.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".list {\n  overflow-y: auto;\n  flex-basis: 450px !important;\n}\n\n.overrides {\n  height: 100%;\n}\n\n.header {\n  padding: var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.addButton {\n  margin-top: var(--size-padLarge);\n}\n\n@media only screen and (max-width: 768px) {\n  .header {\n    padding: 0;\n  }\n\n  .overrides {\n    height: auto;\n    min-width: none;\n  }\n\n  .list {\n    flex-basis: auto !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list_WUyQt`,
	"overrides": `overrides_zrkYF`,
	"header": `header_AMt7S`,
	"addButton": `addButton_x7xd1`
};
export default ___CSS_LOADER_EXPORT___;
